
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import Flash from '../Flash/Flash';
import Menu from '../../images/menu.svg';

import { Internet, Logo } from '../../images';

import { HomeAnnatelURL, SmallLanguageButton } from '../../localeAssets';
import { NavSidebarItems } from './';

import SetLanguageButton from '../../localeAssets/SetLanguageButton';

let Navbar = ({message, location, translate, rest, match, currentLanguage, dispatch }) => {
  return (
    <div className="services">
      <div className="ng-scope ng-isolate-scope">
        <div id="betaAlert">
        { currentLanguage === "fr_FR" ? <p className="alert-beta-mobile alert-feedback-mobile hidden-lg-up" >{translate('beta-message')}<a href="https://www.annatel.co.il/client.php/jauth_client/login/form?auth_url_return=%2Fclient.php">{translate('beta-link')}</a></p> : "" }
        { currentLanguage === "fr_FR" ? <p className="alert-beta alert-feedback hidden-md-down" >{translate('beta-message')}<a href="https://www.annatel.co.il/client.php/jauth_client/login/form?auth_url_return=%2Fclient.php">{translate('beta-link')}</a></p> : "" }
      </div>
        <div id="navbar">
            <nav className="navbar navbar-toggleable-md navbar-light fixed-top" >
              <div className="container" >
                <div className="navbar-header">
                  <div className="row">
                    <div className="col-4 text-left d-lg-none">
                      <button className="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse" >
                        <span className="navbar-toggler-icon"><img style={{height: '1.5em'}} alt="personal-information-icon" src={Menu} /></span>
                      </button>
                    </div>
                    <div className="col-4 text-center">
                      <Link className="nav-link" ui-sref="personal-information" to={`/${currentLanguage}/services/lines-mobile`} match={match} >
                        <span ><img  alt="personal-information-icon" style={{height: '2em'}} src={Logo} /></span>
                      </Link>
                    </div>
                    <div className="col-4 text-right d-lg-none">
                        <SmallLanguageButton  location={location} />
                    </div>
                  </div>
                </div>
                <div id="top-menu" className="navbar-collapse collapse" >
                  <ul className="navbar-nav hidden-md-down ">
                    <li className="nav-item">
                      <a className="nav-link" href={HomeAnnatelURL()}>
                        <span><img  alt="LOGO" style={{height: '2em'}} src={Internet} />{`  ${translate('go-back-to-the-Annatel-website')}`}</span>
                      </a>
                    </li>
                    <li className="nav-item language-left-border">
                      <SetLanguageButton location={location} className="nav-link" />
                    </li>
                  </ul>
                  <div className="hidden-lg-up">
                      <div id="sidebar">
                          <h2 className="hidden-md-down">espace client</h2>
                            <div className="hidden-md-down">
                              <div id="sidebar">
                                <h2 className="hidden-md-down">{translate('customer-area')}</h2>

                              </div>
                            </div>
                          {NavSidebarItems(location, translate, match, currentLanguage, dispatch)}
                      </div>
                  </div>
                </div>
              </div>
            </nav>
          {message && <Flash  message={message}/>}
        </div>

      </div>
    </div>
  );
};


const mapStateToProps = (state, { location, rest }) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    message: state.Flash.message,
    location,
    rest,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch
  };
};

Navbar = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Navbar);

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navigation/Navbar.js